import { sendEvent } from 'libs/event';
import urlParams from 'libs/query';

const baseSendEventAction = ({ url, status, moduleName, time }: any) => {
    sendEvent('ecommerce_tect_stat', {
        api_path: url,
        fe_flag: status,
        time_interval: time,
        page_name: moduleName
    });
};

interface BaseStatProps {
    url: string;
    status: number;
    time?: number;
}

let ACTION_TIME_MAP = {
    START_REQUEST_TIME: 0,
    LOADING_DISSMISS_TIME: 0
};

// 上报数据预取失败上报
export const sendPrefetchActionFailed = ({ url, status }: BaseStatProps) => {
    baseSendEventAction({
        url,
        status,
        time: 'no use',
        moduleName: 'buynow_prefetch_failed'
    });
};

// 上报数据预取接口时延
export const sendPrefetchActionStatus = ({ url, status, time }: BaseStatProps) => {
    baseSendEventAction({
        url,
        time,
        status,
        moduleName: 'buynow_main_api_time_prefetch'
    });
};

// 上报常规接口时延
export const sendMainApiTime = ({ url, status, time }: BaseStatProps) => {
    baseSendEventAction({
        url,
        time,
        status,
        moduleName: 'buynow_main_api_time_network'
    });
};

// 上报页面代码执行时延
export const sendCodeCompileTime = () => {
    if (!urlParams.page_init_timestamp) {
        return;
    }
    baseSendEventAction({
        status: urlParams.new_source_type,
        moduleName: 'buynow_enter_code_compile',
        time: Date.now() - urlParams.page_init_timestamp
    });
};

// 用户点击 - baseRequest发出时间
export const sendUserClickToDispatchFirstRequest = () => {
    ACTION_TIME_MAP.START_REQUEST_TIME = Date.now();
    if (!urlParams.page_init_timestamp) {
        return;
    }
    baseSendEventAction({
        status: urlParams.new_source_type,
        moduleName: 'buynow_enter_request_dispatch',
        time: ACTION_TIME_MAP.START_REQUEST_TIME - urlParams.page_init_timestamp
    });
};

// 用户点击到 loading 圆圈消失时延(即所有主接口时延)
export const sendUserClickToDismissLoading = () => {
    ACTION_TIME_MAP.LOADING_DISSMISS_TIME = Date.now();
    if (!urlParams.page_init_timestamp) {
        return;
    }
    baseSendEventAction({
        status: urlParams.new_source_type,
        moduleName: 'buynow_enter_loading_dismiss',
        time: ACTION_TIME_MAP.LOADING_DISSMISS_TIME - urlParams.page_init_timestamp
    });
};

// 影响Loading的请求发出 - 请求返回时延(即所有主接口时延)
export const sendLoadingDurationTime = () => {
    baseSendEventAction({
        status: urlParams.new_source_type,
        moduleName: 'buynow_loading_duration',
        time: ACTION_TIME_MAP.LOADING_DISSMISS_TIME - ACTION_TIME_MAP.START_REQUEST_TIME
    });
};
